(function () {
  function enableIOSAccessoryBar() {
    const Keyboard = window.Capacitor?.Plugins?.Keyboard;

    if (!Keyboard?.setAccessoryBarVisible) return;

    //Enables ios keyboard accessory bar (for every page in our Shopify theme since we load in theme.liquid)
    Keyboard.setAccessoryBarVisible({ isVisible: true }).catch(() => {});

    // Disables ios keyboard accessory bar when leaving page for the external Shopify login page
    window.addEventListener('pagehide', () => {
      Keyboard.setAccessoryBarVisible({ isVisible: false }).catch(() => {});
    });
  }

  if (window.Capacitor?.isNativePlatform?.()) enableIOSAccessoryBar();
})();
